import styled from "styled-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import SignalDropdownLabel from "../SignalsDropdownLabel/SignalDropdownLabel";
import { StyledDropdownLabel } from "../SignalsDropdownLabel/styles";

export const StyledTemplateLabel = styled(SignalDropdownLabel)`
    ${StyledDropdownLabel} {
        font-size: 18px;

        &:after {
            content: ":";
        }
    }
`;

export const StyledViewHeader = styled(FlexRow)`
    justify-content: space-between;

    & > *:not(${StyledTemplateLabel}) {
        flex: 0;
    }

    & ${StyledTemplateLabel} {
        flex: 1 0 auto;
    }
`;
